import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=40f9d890&"
import script from "./suppliers.vue?vue&type=script&lang=js&"
export * from "./suppliers.vue?vue&type=script&lang=js&"
import style0 from "./suppliers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports